import axios from 'axios';


export const clientRestAPICep = axios.create({
  headers: {
    'Content-Type': 'application/json'
  }
});


